import { render } from "./DeliveryReturn.vue?vue&type=template&id=0566388c&scoped=true"
import script from "./DeliveryReturn.vue?vue&type=script&lang=js"
export * from "./DeliveryReturn.vue?vue&type=script&lang=js"

import "./DeliveryReturn.vue?vue&type=style&index=0&id=0566388c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0566388c"

export default script